import { render, staticRenderFns } from "./IconError.vue?vue&type=template&id=d275e22e&scoped=true&"
import script from "./IconError.vue?vue&type=script&lang=js&"
export * from "./IconError.vue?vue&type=script&lang=js&"
import style0 from "./IconError.vue?vue&type=style&index=0&id=d275e22e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d275e22e",
  null
  
)

export default component.exports